import './RiskCalculatorInputs.css';

import { observer } from 'mobx-react';
import * as React from 'react';
import _ from 'lodash';

import { WizDatePicker } from '../wiz-date-picker/wiz-date-picker'
import { WizDropDownMenu } from '../wiz-drop-down-menu/wiz-drop-down-menu'
import { WizTextField } from '../wiz-text-field/wiz-text-field';
import { WizToggle } from '../wiz-toggle/wiz-toggle';

import { RaisedButton } from 'material-ui';
import { Paper } from 'material-ui';
import { Row, Col } from 'react-flexbox-grid';

import currencies from '../../consts/currencies.json';

@observer
class RiskCalculatorInputs extends React.Component {

	getDatePickerProps(name, value, onChange, minDate) {
		return {
      name,
      className: '',
      placeholder: name,
      value,
      autoOk: true,
      onChange: (e,v) => onChange(v),
      required: true,
      maxDate: new Date('1/1/2020'),
      minDate: minDate || new Date('1/1/2016')
		}
	}

	getWizDropDownMenuProps(name, value, removeValue,  onChange) {
	  const values = _.filter(currencies, (item) => item._id !== removeValue);

		return {
      value,
      onChange: (e,i) => {
      	if (i>0) {
          return onChange(values[i - 1]._id)
        }
				return onChange(null);
      },
      values,
      disabled: false,
      placeholder: name,
      className: '',
      showDefaultValue: false,
      usePlainText: true
		}
	}

	getWizTextFieldProps(name, value, onChange) {
	  return {
      id: name,
      className: '',
      type: 'number',
      placeholder: name,
      value,
      onChange: (event) => onChange(+event.target.value)
    }
  }

  getToggleFieldProps(value, onToggle) {
	  return {
      toggled: value,
      label: '',
      onToggle,
    }
  }

  render() {

		const paperStyles = {
      margin: 20,
      textAlign: 'center',
      display: 'inline-block',
		};

		const buttonStyle = {
			margin: 12,
			height: 40,
			width: 200,
			color: 'blue'
		};

		const {
						bookingDate,
						setBookingDate,
            paymentDate,
            setPaymentDate,
            riskPeriod,
            bookingCurrency,
						setBookingCurrency,
            paymentCurrency,
						setPaymentCurrency,
						dealAmount,
						setDealAmount,
						profitMargin,
						setProfitMargin,
            paymentCurrencyIsBase,
            togglePaymentCurrencyIsBase,
            isCalculated,
            avgMarginAtRisk,
            maxMarginAtRisk,
            medianMarginAtRisk,
            getRiskCalculations,
            averageVol,
            maxVol,
            medianVol
		} = this.props.store;

		const redStyle = (maxVol > profitMargin) ? { color:'red' } : null;

	return (
		<Row middle='xs' center='xs'>
			<Col xs={8}>
				<Paper className="calculator" style={ paperStyles } zDepth={ 3 }>
					<div className='content'>
						<Row center='xs'>
							<Col xs={6}><div className="logo"> </div>
							</Col>
						</Row>
						<Row>
							<Col xs={12}>
								<h1 className="title"> Welcome to booking risk calculator </h1>
							</Col>
						</Row>
						<Row start='xs'>
							<Col xsOffset={1} xs={4}>
							Booking date:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizDatePicker {...this.getDatePickerProps('Booking date', bookingDate, setBookingDate) } className='component-size' />
									</Col>
								</Row>
							</Col>
						</Row>
						<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
								Booking currency:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizDropDownMenu {...this.getWizDropDownMenuProps('Booking currency',bookingCurrency, paymentCurrency, setBookingCurrency) } />
									</Col>
								</Row>
							</Col>
						</Row>
						<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
								Supplier payment date:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizDatePicker {...this.getDatePickerProps('Payment date', paymentDate, setPaymentDate, bookingDate) }/>
									</Col>
								</Row>
							</Col>
						</Row>
						<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
							Payment currency:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizDropDownMenu {...this.getWizDropDownMenuProps('Payment currency',paymentCurrency, bookingCurrency, setPaymentCurrency) }/>
									</Col>
								</Row>
							</Col>

						</Row>
						<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
								Profit margin:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizTextField {...this.getWizTextFieldProps('Profit margin', profitMargin, setProfitMargin)} />%
									</Col>
								</Row>
							</Col>
						</Row>
						{ false ? (<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
								Base currency switch:
							</Col>
							<Col xs={7} >
								<Row start='xs'>
									<Col xs={2}>
								{ bookingCurrency }
									</Col>
									<Col xs={2}>
										<WizToggle {...this.getToggleFieldProps(paymentCurrencyIsBase, togglePaymentCurrencyIsBase)}/>
									</Col>
									<Col xs={8}>
										{ paymentCurrency}
									</Col>
								</Row>
							</Col>
						</Row>) : null }
						<Row middle='xs' start='xs'>
							<Col xsOffset={1} xs={4} >
								Deal amount:
							</Col>
							<Col xs={7}>
								<Row start='xs'>
									<Col xs={12}>
										<WizTextField {...this.getWizTextFieldProps('Deal Amount', dealAmount, setDealAmount)} /> { bookingCurrency }
									</Col>
								</Row>
							</Col>
						</Row>
						<Row middle='xs' center='xs'>
							{ riskPeriod && bookingCurrency && paymentCurrency && profitMargin && dealAmount ?
								(<RaisedButton onClick={ getRiskCalculations } buttonStyle={ buttonStyle }>Calculate the risk</RaisedButton>) : null }
						</Row>
						{ isCalculated ? (<div>
								<Row start='xs'>
									<Col xsOffset={1} xs={11} className='result-title'>
										Risk assessment results:
									</Col>
								</Row>
              <Row middle='xs' start='xs'>
                <Col xsOffset={1} xs={8}>
                  Risk period is: { riskPeriod } days
                </Col>
              </Row>
							<Row middle='xs' start='xs'>
								<Col xsOffset={1} xs={8}>
									Average period volatility: { averageVol }%
								</Col>
							</Row>
							<Row middle='xs' start='xs'>
								<Col xsOffset={1} xs={8}>
									Top 25 period volatility: { medianVol }%
								</Col>
							</Row>
							<Row  middle='xs' start='xs'>
								<Col xsOffset={1} xs={8}>
									Highest period volatility: { maxVol }%
								</Col>
							</Row >

								<Row start='xs' >
									<Col xsOffset={1} xs={11} className='result-title'>
										Margin at Risk
									</Col>
								</Row>
							<Row middle='xs' start='xs'>
								<Col xsOffset={1} xs={8}>
									Average: { avgMarginAtRisk }% { (averageVol*dealAmount/100).toFixed(0) } { bookingCurrency } out of { (dealAmount*profitMargin/100).toFixed(0) } { bookingCurrency }
								</Col>
							</Row>
							<Row middle='xs' start='xs'>
								<Col xsOffset={1} xs={8}>
									Top 25: { medianMarginAtRisk }% { (medianVol*dealAmount/100).toFixed(0) } { bookingCurrency } out of { (dealAmount*profitMargin/100).toFixed(0) } { bookingCurrency }
								</Col>
							</Row>
							<Row middle='xs' start='xs' style={ redStyle }>
								<Col xsOffset={1} xs={8}>
									Max: { maxMarginAtRisk }% { (maxVol*dealAmount/100).toFixed(0) } { bookingCurrency } out of { (dealAmount*profitMargin/100).toFixed(0) } { bookingCurrency }
								</Col>
							</Row>
								<Row middle='xs' start='xs'>
									<Col xsOffset={1} xs={8}>
										* Calculations are based on 2014-2018 daily rates
									</Col>
								</Row>
							</div>
				 ) : null }
					</div>
				</Paper>
			</Col>
		</Row>
	);
  }
}

export default RiskCalculatorInputs;




// WEBPACK FOOTER //
// ./src/components/RiskCalculatorInputData/RiskCalculatorInputs.js